module.exports = __webpack_public_path__ + "img/invoices.14c00d71.svg";